module.exports = __webpack_public_path__ + "media/site_templates/www.localhandyman.net.au/images/feature_3-2b94a8fbaf2da8a496f6fc21a9e957b1.jpeg";